import React, { useEffect, useState } from "react";
import {
  Card,
  Avatar,
  Spin,
  message,
} from "antd";
import {
  UserOutlined,
  CameraOutlined,
} from "@ant-design/icons";
import api from "../../../api/api";

const UserProfile = ({
  darkMode,
  collapsed,
  screens,
}) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] =
    useState(false);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await api.get(
        "/users/"
      );

      const userData = Array.isArray(
        response.data
      )
        ? response.data[0]
        : response.data;

      setUser(userData);
    } catch (error) {
      console.error(
        "Profile fetch error:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  const handleProfileImageChange =
    async (e) => {
      const file =
        e.target.files?.[0];

      if (!file) return;

      const formData =
        new FormData();
      formData.append(
        "profile_image",
        file
      );

      try {
        setUploading(true);

        await api.put(
          "/api/users/user/profileimage/",
          formData,
          {
            headers: {
              "Content-Type":
                "multipart/form-data",
            },
          }
        );

        message.success(
          "Profile image updated successfully"
        );

        fetchProfile();
      } catch (error) {
        console.error(error);

        message.error(
          "Failed to update profile image"
        );
      } finally {
        setUploading(false);

        // reset input
        e.target.value = "";
      }
    };

  if (loading) {
    return (
      <Card
        bordered={false}
        style={{
          borderRadius: 20,
          textAlign: "center",
          background: darkMode
            ? "linear-gradient(135deg,#0B6E4F,#14532D)"
            : "linear-gradient(135deg,#0B6E4F,#15803D)",
        }}
      >
        <Spin />
      </Card>
    );
  }

  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 20,
        background: darkMode
          ? "linear-gradient(135deg,#0B6E4F,#14532D)"
          : "linear-gradient(135deg,#0B6E4F,#15803D)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
        }}
      >
        {/* Avatar Section */}
        <div
          style={{
            position: "relative",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              border:
                "3px solid #F97316",
              borderRadius: "50%",
              padding: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow:
                "0 0 0 2px rgba(255,255,255,0.15)",
            }}
          >
            <Avatar
              size={
                collapsed &&
                screens.md
                  ? 42
                  : 52
              }
              src={
                user?.profile_image
              }
              icon={
                <UserOutlined />
              }
              style={{
                background:
                  "#ffffff",
                color:
                  "#0B6E4F",
              }}
            />
          </div>

          {/* Hidden File Input */}
          <input
            id="profile-image-upload"
            type="file"
            accept="image/*"
            style={{
              display: "none",
            }}
            onChange={
              handleProfileImageChange
            }
          />

          {/* Camera Button */}
          <label
            htmlFor="profile-image-upload"
            style={{
              position:
                "absolute",
              bottom: -4,
              right: -4,
              width: 24,
              height: 24,
              borderRadius: "50%",
              background:
                darkMode
                  ? "#1f2937"
                  : "#ffffff",
              border:
                "1px solid rgba(0,0,0,0.1)",
              display: "flex",
              alignItems:
                "center",
              justifyContent:
                "center",
              cursor: uploading
                ? "not-allowed"
                : "pointer",
              boxShadow:
                "0 4px 12px rgba(0,0,0,0.2)",
              transition:
                "all 0.2s ease",
              zIndex: 10,
            }}
          >
            {uploading ? (
              <Spin
                size="small"
              />
            ) : (
              <CameraOutlined
                style={{
                  fontSize: 12,
                  color: darkMode
                    ? "#ffffff"
                    : "#555555",
                }}
              />
            )}
          </label>
        </div>

        {/* User Details */}
        {(!collapsed ||
          !screens.md) && (
          <div
            style={{
              overflow:
                "hidden",
              flex: 1,
              minWidth: 0,
            }}
          >
            {/* Username */}
            <div
              style={{
                color:
                  "#ffffff",
                fontWeight: 700,
                fontSize: 16,
                whiteSpace:
                  "nowrap",
                overflow:
                  "hidden",
                textOverflow:
                  "ellipsis",
              }}
            >
              {user?.username}
            </div>

            {/* Email */}
            {user?.email && (
              <div
                style={{
                  color:
                    "rgba(255,255,255,0.75)",
                  fontSize: 12,
                  whiteSpace:
                    "nowrap",
                  overflow:
                    "hidden",
                  textOverflow:
                    "ellipsis",
                }}
              >
                {user.email}
              </div>
            )}

            {/* User Type */}
            {user?.user_type && (
              <div
                style={{
                  color:
                    "rgba(255,255,255,0.85)",
                  fontSize: 11,
                  marginTop: 2,
                  textTransform:
                    "capitalize",
                }}
              >
                {user.user_type.replace(
                  "_",
                  " "
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </Card>
  );
};

export default UserProfile;



// import React, { useEffect, useState } from "react";
// import { Card, Avatar, Spin } from "antd";
// import { UserOutlined } from "@ant-design/icons";
// import api from "../../../api/api";

// const UserProfile = ({
//   darkMode,
//   collapsed,
//   screens,
// }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchProfile();
//   }, []);

//   const fetchProfile = async () => {
//     try {
//       const response = await api.get("/users/");

//       const userData = Array.isArray(response.data)
//         ? response.data[0]
//         : response.data;

//       setUser(userData);
//     } catch (error) {
//       console.error("Profile fetch error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <Card
//         bordered={false}
//         style={{
//           borderRadius: 20,
//           textAlign: "center",
//           background: darkMode
//             ? "linear-gradient(135deg,#0B6E4F,#14532D)"
//             : "linear-gradient(135deg,#0B6E4F,#15803D)",
//         }}
//       >
//         <Spin />
//       </Card>
//     );
//   }

//   return (
//     <Card
//       bordered={false}
//       style={{
//         borderRadius: 20,
//         background: darkMode
//           ? "linear-gradient(135deg,#0B6E4F,#14532D)"
//           : "linear-gradient(135deg,#0B6E4F,#15803D)",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 14,
//         }}
//       >
//         {/* <Avatar
//           size={
//             collapsed && screens.md
//               ? 42
//               : 52
//           }
//           src={user?.profile_image}
//           icon={<UserOutlined />}
//           style={{
//             background: "#ffffff",
//             color: "#0B6E4F",
//             flexShrink: 0,
//           }}
//         /> */}

//         <div
//   style={{
//     border: "3px solid #F97316", 
//     borderRadius: "50%",
//     padding: 2,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//     boxShadow:
//       "0 0 0 2px rgba(255,255,255,0.15)",
//   }}
// >
//   <Avatar
//     size={
//       collapsed && screens.md
//         ? 42
//         : 52
//     }
//     src={user?.profile_image}
//     icon={<UserOutlined />}
//     style={{
//       background: "#ffffff",
//       color: "#0B6E4F",
//       display: "block",
//     }}
//   />
// </div>

//         {(!collapsed || !screens.md) && (
//           <div
//             style={{
//               overflow: "hidden",
//               flex: 1,
//             }}
//           >
//             {/* Username */}
//             <div
//               style={{
//                 color: "#ffffff",
//                 fontWeight: 700,
//                 fontSize: 16,
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               {user?.username}
//             </div>

//             {/* Email */}
//             <div
//               style={{
//                 color:
//                   "rgba(255,255,255,0.75)",
//                 fontSize: 12,
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               {/* {user?.email} */}
//             </div>

//             {/* User Type */}
//             <div
//               style={{
//                 color:
//                   "rgba(255,255,255,0.85)",
//                 fontSize: 11,
//                 marginTop: 2,
//                 textTransform: "capitalize",
//               }}
//             >
//               {user?.user_type?.replace(
//                 "_",
//                 " "
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </Card>
//   );
// };

// export default UserProfile;